import styled from "styled-components";
import { tokens } from "../../../public/tokens";

export const StyledCard = styled.section({
  width: "100%",
  background: tokens.colors.surfaces["container-background"],
  border: `1px solid ${tokens.colors.surfaces["border-divider"]}`,
  borderRadius: tokens.globals["border-radius"],
  boxShadow: tokens.effects.effects.shadow.default,
  overflow: "hidden",

  "& .search-filter-div": {
    margin: 0,
    padding: `19px ${tokens.globals["spacing-4"]} ${tokens.globals["spacing-5"]}`,
    minHeight: "74px",
    alignItems: "flex-start",
    boxSizing: "border-box",
  },

  "& .dataTables_filter label": {
    position: "relative",
    display: "block",
  },
  "& .dataTables_filter label::before": {
    display: "none !important",
  },
  "& .dataTables_filter i.fa-search": {
    position: "absolute",
    left: tokens.globals["spacing-3"],
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: tokens.typography.fontSize["base-16px"],
    color: tokens.colors.neutral.grey["600"],
    pointerEvents: "none",
    zIndex: 1,
  },

  "& .dataTables_filter input": {
    width: "166px !important",
    height: "35px !important",
    boxSizing: "border-box",
    margin: "0 !important",

    border: `1px solid ${tokens.colors.surfaces["border-divider"]} !important`,
    borderRadius: "8px !important",
    background: `${tokens.colors.neutral.white} !important`,

    padding: `${tokens.globals["spacing-1"]} ${tokens.globals["spacing-3"]} ${tokens.globals["spacing-1"]} 40px !important`,

    fontFamily: `${tokens.typography.fontFamilies["albert-sans"]} !important`,
    fontSize: `${tokens.typography.fontSize["lg-14px"]} !important`,
    fontWeight: `${tokens.typography.fontWeights.regular} !important`,
    lineHeight: "20px !important",
    color: `${tokens.colors.neutral.grey["600"]} !important`,

    outline: "none",

    "&::placeholder": {
      color: `${tokens.colors.neutral.grey["600"]} !important`,
    },

    "&:focus": {
      borderColor: `${tokens.colors.ui.ring} !important`,
    },
  },
});

export const StyledProgressContainer = styled.div({
  width: "100%",
  marginBottom: tokens.globals["spacing-4"],
});

/*
 * Reserves room at the bottom of the page for the fixed-position bulk-action bar.
 * Animated (not conditionally mounted) so selecting/clearing rows doesn't snap the
 * table into a new height — it eases in alongside the bar's own entrance animation.
 * $height comes from measuring the bar's actual rendered height (it can grow when
 * its buttons wrap onto a second line), falling back to a single-row estimate for
 * the one frame before that measurement lands, so content is never trapped behind it.
 * The bar itself floats `spacing-xl` above the viewport bottom, so that gap is added
 * on top of its height to reserve the exact space it occupies.
 */
export const StyledBulkActionSpacer = styled.div(({ $active = false, $height = 0 }) => ({
  width: "100%",
  height: $active
    ? `calc(${Math.max($height, 84)}px + ${tokens.globals["spacing-xl"]})`
    : "0",
  transition: "height 200ms cubic-bezier(0.16, 1, 0.3, 1)",
}));

export const StyledLinkTableBody = styled.div({
  width: "100%",

  ".modal-header": {
    display: "none",
  },
});

